import React, { Component } from 'react'

export default class StageQueue extends Component {
    state = {
        DownloaderStatus: [
            { progress: '70%', bgcolor: 'rgb(232, 60, 60)', status: 'Failed' },
            { progress: '70%', bgcolor: 'rgb(113, 200, 240)', status: '5.3GB' },
            { progress: '70%', bgcolor: 'rgb(113, 200, 240)', status: '5.3GB' },
            { progress: '63%', bgcolor: 'rgb(113, 200, 240)', status: '4.3 / 5.3GB' },
            { progress: '63%', bgcolor: 'rgb(113, 200, 240)', status: '4.3 / 5.3GB' },
            { progress: '70%', bgcolor: 'rgb(113, 200, 240)', status: '5.3GB' },
            { progress: '70%', bgcolor: 'rgb(232, 60, 60)', status: 'Failed' },
        ]
    }
    render() {
        return (
            <div className='py-2 px-4'>
                <div className=' w-100'>
                    {this.state.DownloaderStatus.map((prop, index) => {
                        return (
                            <>
                                <p className='mb-0 text-small'>File Name</p>

                                <div className='flexcb w-100'>
                                    <div className='flexc mrd-4 w-100' >
                                        <img className='mrd-2' height='25px' src="/images/file.png" alt="" />
                                        <div className='w-100 flexc br-10 mrd-4 flex-1' style={{ height: '10px', overflow: 'hidden', background: 'rgba(239, 239, 239, 0.5)' }}>
                                            <div style={{ background: prop.bgcolor, width: prop.progress, height: '10px' }}>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mld-4'>
                                        <img height="13px" src="/images/close.png" alt="" />
                                    </div>
                                </div>
                                <p className='text-smaller' style={{ width: '100px', whiteSpace: 'nowrap' }}>{prop.status}</p>
                                <div className='py-2' style={{ borderBottom: '1px solid rgba(244, 227, 227 , 0.3)' }}></div>
                            </>
                        )
                    })}
                </div>
            </div>
        )
    }
}
